/// <amd-module name="Core/Medius.Core.Web/Scripts/components/readonlyTabs/amounts"/>
import * as React from 'react';
import { IDocumentImportInformation } from "../interfaces";
import { ContentDivider, FixedGridLayout, LockedField, SwitchField } from "@medius/ui-controls";
import { translate } from 'Core/Medius.Core.Web/Scripts/lib/globalization';

interface AmountsProps {
    information: IDocumentImportInformation;
}

const isNil = (value: unknown): value is null | undefined =>
    value === null || value === undefined;

const isNullOrEmpty = (value?: string | null): boolean =>
    value === null || value === undefined || value === "";

export const isAnyAmountsNotEmpty = (information: IDocumentImportInformation): boolean =>
    !isNullOrEmpty(information?.amountsCurrency) ||
    !isNil(information?.amountsNetAmount) ||
    !isNil(information?.amountsTax) ||
    !isNil(information?.amountsRounding) ||
    !isNil(information?.amountsTotal);

export const AmountsDetails = (props: AmountsProps) => {
    return (
        <>
            <FixedGridLayout columns={1} >
                <SwitchField
                        fieldLabel={translate("#PurchaseToPay/isCurrencyRateImported")}
                        inputProps={{value: props.information?.isCurrencyRateImported !== null && props.information?.isCurrencyRateImported !== undefined ? props.information?.isCurrencyRateImported : false}}
                        disabled={true}
                    />
                {props.information?.isCurrencyRateImported && (
                    <LockedField
                        fieldLabel={translate("#Core/currencyRate")}
                        valueText={props.information?.currencyRate !== null && props.information?.currencyRate !== undefined ? props.information?.currencyRate.toFixed(2) : '-'}
                    />
                )}

                <LockedField
                    fieldLabel={translate("#Core/currency")}
                    valueText={props.information?.amountsCurrency || '-'}
                />
                <ContentDivider />
                <LockedField
                    fieldLabel={translate("#PurchaseToPay/reporting/columns/NetAmount")}
                    valueText={props.information?.amountsNetAmount !== null && props.information?.amountsNetAmount !== undefined ? props.information?.amountsNetAmount.toFixed(2) : '-'}
                />
                <LockedField
                    fieldLabel={translate("#Enterprise/tax")}
                    valueText={props.information?.amountsTax !== null && props.information?.amountsTax !== undefined ? props.information?.amountsTax.toFixed(2) : '-'}
                />
                <LockedField
                    fieldLabel={translate("#PurchaseToPay/reporting/columns/Rounding")}
                    valueText={props.information?.amountsRounding !== null && props.information?.amountsRounding !== undefined ? props.information?.amountsRounding.toFixed(2) : '-'}
                />
                <LockedField
                    fieldLabel={translate("#PurchaseToPay/totalAmount")}
                    valueText={props.information?.amountsTotal !== null && props.information?.amountsTotal !== undefined ? props.information?.amountsTotal.toFixed(2) : '-'}
                />
            </FixedGridLayout>
        </>
    );
};